<template>
  <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12554_92749)">
      <g clip-path="url(#clip1_12554_92749)">
        <path d="M18.9898 0H0V11.9995H18.9898V0Z" fill="white"/>
        <path d="M8.54556 7.19607V11.9996H10.4443V7.19607H18.9898V4.79717H10.4443V0H8.54556V4.79717H0V7.19607H8.54556Z"
              fill="#CF142B"/>
        <path d="M11.0781 3.88447V0H17.2271L11.0781 3.88447Z" fill="#00247D"/>
        <path d="M11.0781 8.11475V11.9992H17.2271L11.0781 8.11475Z" fill="#00247D"/>
        <path d="M7.91402 8.11475V11.9992H1.76562L7.91402 8.11475Z" fill="#00247D"/>
        <path d="M7.91402 3.88447V0H1.76562L7.91402 3.88447Z" fill="#00247D"/>
        <path d="M0 1.11572V4.00034H4.56569L0 1.11572Z" fill="#00247D"/>
        <path d="M18.9947 1.11572V4.00034H14.4297L18.9947 1.11572Z" fill="#00247D"/>
        <path d="M18.9947 10.8846V8H14.4297L18.9947 10.8846Z" fill="#00247D"/>
        <path d="M0 10.8846V8H4.56569L0 10.8846Z" fill="#00247D"/>
        <path d="M18.9917 0H17.9372L11.6172 4.00006H12.6717L19.0018 0" fill="#CF142B"/>
        <path d="M7.37452 8H6.32003L0 11.9994H1.0545L7.38466 8" fill="#CF142B"/>
        <path d="M5.27376 4.00259H6.32826L0 0V0.670782L5.27376 4.00259Z" fill="#CF142B"/>
        <path d="M13.7107 7.99756H12.6562L18.9845 12.0001V11.3294L13.7107 7.99756Z" fill="#CF142B"/>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12554_92749">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
      <clipPath id="clip1_12554_92749">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'FlagEN',
}
</script>
